import { HeaderTextProps } from 'components/organisms/Header/types';

const header: HeaderTextProps = {
  headerText: {
    greetings: 'Halo',
    intro: "Saya",
    preTitle: '',
  },
  scrollDown: 'Scroll ke bawah',
};

export default header;
